module.exports = __webpack_public_path__ + "img/traditional-chinese.54155626.jpg";